import type {ReactElement} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Checkbox, CHECKBOX_TYPE} from '@Components/checkbox-legacy';
import {toggleValue} from '@Components/ai-chat-window/components/survey/fields/fields.library';
import {otherKey} from '@Components/ai-chat-window/components/survey/survey.library';
import type {MultiSelectFieldRendererProps} from './fields.types';
import {OptionCard} from './option-card';
import styles from './fields.module.scss';

export function MultiSelectFieldRenderer({name, step, field}: MultiSelectFieldRendererProps): ReactElement {
  const {control, setValue} = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={[]}
      render={({field: rhfField}): ReactElement => {
        const current: string[] = Array.isArray(rhfField.value) ? (rhfField.value as string[]) : [];
        return (
          <div
            className={styles.optionList}
            role="group"
            aria-label={step.helpText}
          >
            {field.options.map((opt) => {
              const isChecked = current.includes(opt.value);
              return (
                <OptionCard
                  key={opt.value}
                  label={opt.label}
                  imageUrl={opt.imageUrl}
                  isSelected={isChecked}
                  leadingSlot={<Checkbox isChecked={isChecked} type={CHECKBOX_TYPE.PRIMARY_LIGHT} />}
                  onClick={(): void => {
                    setValue(otherKey(name), '');
                    rhfField.onChange(toggleValue(current, opt.value));
                  }}
                />
              );
            })}
          </div>
        );
      }}
    />
  );
}
